
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { UpdateRewardModel } from "@models/reward";
import ImagePreviewModel from "crop-image/src/ImagePreviewModel";

@Component
export default class CreateAffirmationComponent extends Vue {
  languages: string[] = [];
  isLoading = false;
  isEditAudio = false;
  currentReward: UpdateRewardModel = new UpdateRewardModel();

  get title(): string {
    return this.id ? "Редактирование награды" : "Добавление награды";
  }

  get id(): number {
    const routeId = this.$route.params.id;
    return routeId ? Number(routeId) : 0;
  }

  async created() {
    this.languages = await this.$cacheProvider.getLanguagesAsync();
    this.currentReward.initLanguages(this.languages);
    if (this.$route.params.id) {
      await this.fetchData();
    }
  }

  async fetchData() {
    this.isLoading = true;
    const res = await this.$api.RewardService.getRewardAsync(this.id);
    this.currentReward.fromServerModel(res);
    this.isLoading = false;
  }

  async save() {
    if (!(this.$refs.translationTabs as any).isValid()) return;
    this.syncRewardImage();
    const isValid = (this.$refs.validator as any).isValid() && this.validateIcon();
    if (!isValid) return;
    this.isLoading = true;
    const request = this.currentReward.toServerModel();
    try {
      const res = await this.$api.RewardService.updateRewardAsync(request);
      if (res) {
        this.$dialog.success("Награда успешно обновлена");
        this.$router.back();
      }
      this.isLoading = false;
    } catch (e) {
      this.$notification.error((e as any).ErrorMessage);
      console.error(e);
    } finally {
      this.isLoading = false;
    }
  }

  syncRewardImage() {
    const image = (this.$refs.iconImageCroper as any)?.getFile?.();
    if (image && image.ImageUrl) {
      this.currentReward.iconImage = image as ImagePreviewModel;
    }
  }

  validateIcon(): boolean {
    const isValid = (this.$refs.iconImageCroper as any)?.isValid?.() !== false;
    if (!isValid) {
      return false;
    }
    if (!this.currentReward.hasIconImage) {
      this.$notification.error("Добавьте значок");
      return false;
    }
    return true;
  }
}
